export default {
  baseURL: "http://localhost",
  googleAPIKey: "AIzaSyAZL6EkeuuR-c97CpkOkAYc55Aqan_izZM",
};
